<template>
    <modal
        :active="active"
        @closed="onClose"
        title="Rediger overdue"
    >
        <div class="columns is-tablet">
            <form-field
                class="column"
                label="Dato for overdue"
                :error="error.overdue_at"
            >
                <div class="field is-grouped">
                    <div class="control">
                        <InputDate
                            ref="new_date"
                            inputSize="normal"
                            :hide-input="true"
                            @select="selectDate"
                        >
                            <div class="field has-addons">
                                <button class="button">
                                <span class="icon is-small">
                                    <i class="fa fa-calendar"></i>
                                </span>
                                    <span v-if="date">{{ date }}</span>
                                </button>
                                <button class="button" :disabled="false" v-if="!date">
                                    Vælg dato
                                </button>
                                <button class="button is-default" v-if="date" @click.prevent="date = null">
                                    Fjern dato
                                </button>
                            </div>
                        </InputDate>
                    </div>
                </div>
            </form-field>
        </div>

        <template v-slot:footer class="has-space-between">
            <div class="footer-spacer">
                <div>
                    <button class="button is-default" @click.prevent="onClose">Annuller</button>
                    <button class="button is-primary" @click.prevent="onUpdateDate">Gem</button>
                </div>
            </div>
        </template>
    </modal>
</template>

<script>
import Modal from '@elems/modal'
import {FormField, InputDate} from '@elems/form'
import {bodyOpen} from "../../functions/bodyLock";

export default {
    components: {
        Modal,
        FormField,
        InputDate,
    },
    props: {
        active: Boolean,
        defaultDate: {
            type: [String, Date, Object],
            default: () => null
        },
        project: Object,
    },
    data() {
        return {
            date: null,
            error: [],
        }
    },
    methods: {
        onClose() {
            bodyOpen();
            this.$emit('closed', true);
        },
        selectDate(value) {
            this.date = value;
        },
        async onUpdateDate() {
            await this.$store.dispatch('changeProjectOverdueDate', {
                projectId: this.project.id,
                overdueDate: this.date,
            });
            this.$emit('updated');
            this.onClose();
        },
    },
    mounted() {
        if (this.defaultDate) {
            this.date = this.defaultDate;
        }
    }
}
</script>

<style lang="scss" scoped>
.footer-spacer {
    width: 100%;
    display: flex;
    flex-direction: row-reverse;
    justify-content: space-between;
}
</style>
